/**
 * The frontend's version, in ONE place.
 *
 * Bumped with every release alongside BACKEND_VERSION (backend/app_version.py)
 * and CACHE_VERSION (public/sw.js).
 *
 * WHY ITS OWN MODULE: two places needed this number and neither knew about the
 * other. The Settings footer was bumped every release; the Sentry release tag
 * in index.js was written once as "xelanti-frontend@10.49" and never touched
 * again. By 26 Aug 2026 production was on 16.67 and every error Sentry filed
 * was attributed to a build six major versions stale - so "which release did
 * this start in?" had no answer, and a regression could not be dated.
 *
 * Same failure as the hardcoded "v7.9" in /api/health: a version marker that
 * can drift silently is worse than none, because it is believed.
 *
 * BUMP THIS EVERY RELEASE. check_release_version.py fails the gate if it
 * disagrees with BACKEND_VERSION, or if a literal reappears at either use site.
 */

export const APP_VERSION = "19.25";

/** Tag Sentry expects: "xelanti-frontend@16.68". */
export const SENTRY_RELEASE = `xelanti-frontend@${APP_VERSION}`;
